<style lang="scss" scoped>
.email-format {
}
</style>
<template lang="pug">
div.email-format
    el-form(label-position="top")
        el-form-item(label="How many letters from the first name do you want to use?")
            el-input-number(:min="2", :max="5", size="medium", v-model="lettersToUseFirstN")
        el-form-item(label="How many letters from the last name do you want to use?")
            el-input-number(:min="2", :max="5", size="medium", v-model="lettersToUseLastN")
        el-form-item(:label="fieldLabel || 'Email format'")
            el-select(v-model="emailFormat", @change="changeDBFormat")
                el-option(label="Custom...", value="custom")
                el-option-group(v-for="(group, i) in formats" :key="i" :label="group.label" :value="group.value")
                    el-option(v-for="(item, j) in group.options" :key="item.label" :label="`${item.label} (e.g. ${applyFormat(item.label, users[0])})`" :value="item.value")
        el-form-item(label="Custom format", v-if="emailFormat === 'custom'")
            el-input(v-model="customFormat", style="width:90%", ref="customFormatInput", @change="changeDBFormat")
            el-select(v-model="chunkPicker", style="width:10%", @change="changeChunk")
                el-option(label="+", value="+")
                el-option(v-for="(field, j) in Object.keys(fieldNames)" :key="field" :value="field" :label="`${fieldNames[field].label} (${field})`" v-if="!excludedFields.includes(field)")
            el-alert(type="warning" style="line-height: 20px" description="{number} will be automatically appended at the end of the format when not selected to prevent duplicate email addresses. A number will only be appended if there is otherwise to be a duplicate email address added when creating a user.")
        el-form-item
            el-table(:data="users")
                el-table-column(label="First Name",  prop="firstname", width="150")
                el-table-column(label="Surname", prop="surname", width="150")
                el-table-column(label="Generated Email Address")
                    template(slot-scope="scope", ref="parentSlot")
                        p(v-if="emailFormat === 'custom'") {{ applyFormat(customFormat, scope.row) }}
                        p(v-else) {{ applyFormat(emailFormat, scope.row) }}
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";

export default {
    props: {
        userType: String,
        fieldLabel: String,
        domain: String,
        excludedFields: Array,
    },
    data() {
        return {
            surnames: ["Liam", "Olivia", "Noah", "Emma", "Ava", "William", "Sophia", "James", "Isabella", "Logan", "Mia", "Benjamin", "Charlotte", "Mason", "Amelia", "Elijah", "Harper", "Alexander", "Evelyn", "Daniel"],
            firstNames: ["Johnson", "Smith", "Anderson", "Williams", "Jones", "Brown", "Taylor", "Davis", "Miller", "Moore", "Clark", "Wilson", "Anderson", "White", "Thomas", "Harris", "Lewis", "Hall", "Adams", "Baker"],
            users: [],
            lettersToUseFirstN: 0,
            lettersToUseLastN: 0,
            fields: {
                '{surname}': s => s.surname || '',
                '{firstname}': s => s.firstname || '',
                '{surname-initial}': s => (s.surname || '').substring(0, 1),
                '{firstname-initial}': s => (s.firstname || '').substring(0, 1),
                '{firstname-2-letters}': s => (s.firstname || '').substring(0, 2),
                '{surname-2-letters}': s => (s.surname || '').substring(0, 2),
                '{firstname-3-letters}': s => (s.firstname || '').substring(0, 3),
                '{surname-3-letters}': s => (s.surname || '').substring(0, 3),
                '{firstname-4-letters}': s => (s.firstname || '').substring(0, 4),
                '{surname-4-letters}': s => (s.surname || '').substring(0, 4),
                '{firstname-5-letters}': s => (s.firstname || '').substring(0, 5),
                '{surname-5-letters}': s => (s.surname || '').substring(0, 5),
                '{cohort-year}': s => s.cohort.toString().slice(-2) || '',
                '{mis-id}': s => s.misId || '',
                '{mis-secondary-id}': s => s.misSecondaryId || '',
                '{admission-number}': s => s.admissionNumber || '',
                '{admission-date}': s => new Date(s.admissionDate || null).getFullYear().toString() || '',
                '{admission-year}': s => new Date(s.admissionDate || null).getFullYear().toString().slice(-2),
                '{learner-number}': s => s.learnerNumber,
                '{number}': _ => Math.floor((Math.random() * 100))
            },
            dbFields: {
                "last_name": "surname",
                "first_name": "firstname",
                "last_name_letters[0]": "surname-initial",
                "first_name_letters[0]": "firstname-initial",
                "cohort_year.toString().slice(-2)": "cohort-year",
                "mis_id": "mis-id",
                "mis_secondary_id": "mis-secondary-id",
                "education_details.admission_number": "admission-number",
                "education_details.year_of_admission.toString()": "admission-date",
                "education_details.year_of_admission.toString().slice(-2)": "admission-year",
                "education_details.learner_number": "learner-number",
                "number": "number"
            },
            fieldNames: {
                "surname": {
                    label: "Last name",
                    value: "last_name"
                },
                "firstname": {
                    label: "First name",
                    value: "first_name"
                },
                "surname-initial": {
                    label: "Last name initial",
                    value: "last_name_letters[0]"
                },
                "firstname-initial": {
                    label: "First name initial",
                    value: "first_name_letters[0]"
                },
                "cohort-year": {
                    label: "Cohort year",
                    value: "cohort_year.toString().slice(-2)"
                },
                "mis-id": {
                    label: "MIS ID",
                    value: "mis_id"
                },
                "mis-secondary-id": {
                    label: "MIS Secondary ID",
                    value: "mis_secondary_id"
                },
                "admission-number": {
                    label: "Admission number",
                    value: "education_details.admission_number"
                },
                "admission-date": {
                    label: "Admission date",
                    value: "education_details.year_of_admission.toString()"
                },
                "admission-year": {
                    label: "Admission year",
                    value: "education_details.year_of_admission.toString().slice(-2)"
                },
                "learner-number": {
                    label: "Learner number",
                    value: "education_details.learner_number"
                },
                "number": {
                    label: "Number",
                    value: "number"
                }
            },
            formats: [{
                label: 'Standard formats',
                options: [{
                    value: '{surname}{firstname-initial}',
                    label: '{surname}{firstname-initial}'
                }, {
                    value: '{surname}.{firstname-initial}',
                    label: '{surname}.{firstname-initial}'
                }, {
                    value: '{firstname}.{surname-initial}{cohort-year}',
                    label: '{firstname}.{surname-initial}{cohort-year}'
                }]
            }],
            emailFormat: "custom",
            customFormat: "",
            chunkPicker: "+",
            dbFormat: "",
            original: ""
        };
    },

    watch: {
        dbFormat() {
            this.updateModel();
        },
        lettersToUseFirstN() {
            this.addLettersSliceOptions('firstN');
            this.updateModel();
        },
        lettersToUseLastN() {
            this.addLettersSliceOptions('lastN');
            this.updateModel();
        }
    },

    apollo: {
        persistedFormat: {
            query: gql`
                {
                    Settings {
                        id
                        email_format_employee
                        email_format_student
                        email_format_student_split_by_firstN
                        email_format_employee_split_by_firstN
                        email_format_student_split_by_lastN
                        email_format_employee_split_by_lastN
                    }
                }
            `,
            update(r) {
                this.original = r.Settings[`email_format_${this.userType}`];
                this.customFormat = this.convertToDisplayFormat();
                this.lettersToUseFirstN = r.Settings[`email_format_${this.userType}_split_by_firstN`];
                this.lettersToUseLastN = r.Settings[`email_format_${this.userType}_split_by_lastN`];
                this.changeDBFormat();
                this.updateModel();
            }
        },
    },
    mounted() {
        this.addLettersSliceOptions('both')
    },
    created() {
        for (let i = 0; i < 3; i++) this.users.push(this.makeUser());
    },

    methods: {
        addLettersSliceOptions(toAdd) {
            switch (toAdd) {
                case 'firstN':
                    this.fieldNames[`firstname-${this.lettersToUseFirstN}-letters`] = {label: `First name ${this.lettersToUseFirstN} letters`, value: `first_name_letters.slice(0, ${this.lettersToUseFirstN})`}
                    this.dbFields[`first_name_letters.slice(0, ${this.lettersToUseFirstN})`] = `firstname-${this.lettersToUseFirstN}-letters`;
                    break;
                case 'lastN':
                    this.fieldNames[`surname-${this.lettersToUseLastN}-letters`] = {label: `Last name ${this.lettersToUseLastN} letters`, value: `last_name_letters.slice(0, ${this.lettersToUseLastN})`};
                    this.dbFields[`last_name_letters.slice(0, ${this.lettersToUseLastN})`] = `surname-${this.lettersToUseLastN}-letters`;
                    break;
                default:
                    this.fieldNames[`firstname-${this.lettersToUseFirstN}-letters`] = {label: `First name ${this.lettersToUseFirstN} letters`, value: `first_name_letters.slice(0, ${this.lettersToUseFirstN})`}
                    this.dbFields[`first_name_letters.slice(0, ${this.lettersToUseFirstN})`] = `firstname-${this.lettersToUseFirstN}-letters`;
                    this.fieldNames[`surname-${this.lettersToUseLastN}-letters`] = {label: `Last name ${this.lettersToUseLastN} letters`, value: `last_name_letters.slice(0, ${this.lettersToUseLastN})`};
                    this.dbFields[`last_name_letters.slice(0, ${this.lettersToUseLastN})`] = `surname-${this.lettersToUseLastN}-letters`;
                break;
            }
        },
        makeUser() {
            return {
                surname: this.getRandom(this.surnames),
                firstname: this.getRandom(this.firstNames),
                cohort: Math.floor(Math.random() * 20) + 2000,
                misId: this.getUid(),
                misSecondaryId: this.getUid(),
                admissionNumber: Math.floor(Math.random() * 100000),
                admissionDate: new Date('2018-03-01'),
                learnerNumber: Math.floor(Math.random() * 100000)
            };
        },

        getUid() {
            return Math.floor(Math.random() * 100000);
        },

        getRandom(arr) {
            return arr[Math.floor(Math.random() * (arr.length - 1))];
        },
        
        applyFormat(format, user) {
            const chunks = format.split(/(\{.*?\})/);
            const applied = chunks.map(chunk => this.fields[chunk] ? this.fields[chunk](user) : chunk);
            return _.deburr(applied.join(''))
                .toLowerCase() + (`@${this.domain || "edusync.com"}`);
        },

        changeChunk() {
            const customFormatInput = this.$refs.customFormatInput.$refs.input
            let start = customFormatInput.selectionStart;
            let end = customFormatInput.selectionEnd;
            const customFormatValue = Object.assign(this.customFormat);
            const chunkPickerValue = Object.assign(this.chunkPicker);
            this.customFormat = `${customFormatValue.slice(0, start)}{${chunkPickerValue}}${customFormatValue.slice(end)}`;
            start = end = start + `{${chunkPickerValue}}`.length;
            this.changeDBFormat();
            this.chunkPicker = "+";
            this.updateModel();
        },

        changeDBFormat() {
            const chunks = this.getFormat().split(/(\{.*?\})/);
            this.dbFormat = _(chunks)
                .filter((chunk) => {
                    return !_.isEmpty(chunk);
                })
                .map((chunk) => {
                    const key = chunk.replaceAll(/\{|\}/g, "");
                    return this.fieldNames[key] ? `${this.fieldNames[key].value}` : `'${chunk}'`;
                })
                .value()
                .join(" + ");
        },

        convertToDisplayFormat() {
            const chunks = this.original.split(" + ");
            return _(chunks).map((chunk) => {
                return this.dbFields[chunk] ? `{${this.dbFields[chunk]}}` : chunk.replaceAll(/\'/g, "");
            })
            .value()
            .join("");
        },

        updateModel() {
            this.$emit("input", {
                format: this.dbFormat,
                sample: this.users.length ? this.applyFormat(this.getFormat(), this.users[0]) : "",
                countFirstN: this.lettersToUseFirstN,
                countLastN: this.lettersToUseLastN,
            });
        },

        getFormat() {
            return this.emailFormat === "custom" ? this.customFormat : this.emailFormat;
        },
    }
};
</script>

